// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__3Pm_g","rowsWrapper":"style_rowsWrapper__36t2Z","rowWrapper":"style_rowWrapper__1xMec"};